import React, { useContext, useMemo } from "react";
import { HeaderContext } from "../../../../store/context/header-context";
import {
  ACTIVE_LANGUAGES,
  AVAILABLE_LANGUAGES,
} from "../content/index.content";
import { getTrueClasses } from "../../../../helpers";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const LanguageSwitcher = () => {
  const { language, isShowLanguageSwitcher } = useContext(HeaderContext);
  const currentLanguage = useMemo(
    () => (ACTIVE_LANGUAGES.includes(language) ? language : "en"),
    [language]
  );
  const { flag, title } = AVAILABLE_LANGUAGES[currentLanguage];
  return (
    <div
      className={getTrueClasses(
        "GCL-H-LS",
        !isShowLanguageSwitcher && "GCL-H-LS_empty"
      )}
    >
      <div className="GCL-H-LS__btn">
        <img src={flag} alt={title} />
        <span>{title}</span>
      </div>
      <div className="GCL-H-LS-S">
        {ACTIVE_LANGUAGES.map((local) => {
          if (local !== currentLanguage) {
            const { flag, title, path } = AVAILABLE_LANGUAGES[local];
            return (
              <TrackedLink
                key={local}
                class="GCL-H-LS__btn"
                path={path}
                action={local}
                category="MainMenu CTA"
                isLink
              >
                <img src={flag} alt={title} />
                <span>{title}</span>
              </TrackedLink>
            );
          }
        })}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
